import { EmailAccountModel } from "@jugl-web/rest-api";
import { EmailSettingsFormValues } from "../types";

export const getEmailSettingsFormValues = (
  emailAccount: EmailAccountModel | undefined
): EmailSettingsFormValues => ({
  ai_reply: emailAccount?.ai_reply === true,
  use_base_instructions: emailAccount?.metadata?.use_base_instructions ?? true,
  instructions: emailAccount?.metadata?.instructions ?? "",
  ai_email_signature_enabled:
    emailAccount?.metadata?.ai_email_signature_enabled ?? false,
  ai_email_signature: emailAccount?.metadata?.ai_email_signature ?? "",
  ai_msg_disclaimer_enabled:
    emailAccount?.metadata?.ai_msg_disclaimer_enabled ?? false,
  ai_msg_disclaimer: emailAccount?.metadata?.ai_msg_disclaimer ?? "",
  blocked_emails: emailAccount?.metadata?.blocked_emails ?? [],
  pending_blocked_email: "",
});
